import { PositionStatusEnum } from '../../generated-src/client/positions/api';

export type UiVacancyStatus = 'active' | 'paused' | 'archived';

export function getUiVacancyStatusDotClass(status: UiVacancyStatus): string {
  switch (status) {
    case 'active':
      return 'bg-[var(--status-success)]';
    case 'paused':
      return 'bg-[var(--status-warning)]';
    case 'archived':
      return 'bg-[var(--status-neutral)]';
  }
}

export function getUiVacancyStatusLabel(status: UiVacancyStatus): string {
  switch (status) {
    case 'active':
      return 'Активная';
    case 'paused':
      return 'Пауза';
    case 'archived':
      return 'Архив';
  }
}

export function getPositionStatusDotClass(status: PositionStatusEnum): string {
  switch (status) {
    case PositionStatusEnum.ACTIVE:
      return 'bg-[var(--status-success)]';
    case PositionStatusEnum.PAUSED:
      return 'bg-[var(--status-warning)]';
    case PositionStatusEnum.ARCHIVED:
      return 'bg-[var(--status-neutral)]';
  }
}

export function getPositionStatusLabel(status: PositionStatusEnum): string {
  switch (status) {
    case PositionStatusEnum.ACTIVE:
      return 'Активная';
    case PositionStatusEnum.PAUSED:
      return 'Пауза';
    case PositionStatusEnum.ARCHIVED:
      return 'Архив';
  }
}


